import { AxiosInstance } from "axios";
import CommonCRUD from "modules/CommonCRUD";

class OrdersClasses extends CommonCRUD {}

export default OrdersClasses;
